import script from "./NotificationFormMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationFormMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationFormMolecule.css?vue&type=style&index=0&id=70d874d0&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d874d0"]])

export default __exports__